<template>
    <div id="prizes_page" class="">
        <div class="d-flex flex-column flex-lg-row justify-content-between">

            <div class="d-flex w-25">
                <div class="mx-auto pt-2">
                    <!--                    <a href="https://racorestebarbatul.ro/">-->
                    <img src="../assets/img/SkolOriginal_Drept-01.png" alt="" class="logo">
                    <!--                    </a>-->
                </div>
            </div>

            <div class="d-flex flex-column align-items-center w-50 details">

                <div class="header">
                    <div class="px-4 pt-2">
                        <img src="../assets/img/Group60.png" alt="" class="img-fluid">
                    </div>

                    <div class="px-4 pb-lg-5 text2" style="margin-top: 10px">
                        <img src="../assets/img/Group54.png" alt="" class="img-fluid">
                    </div>
                </div>

                <div class="my-3 my-md-0">
                    <Arrows></Arrows>
                </div>

                <div class="prizes w-100 p-md-5 d-flex flex-column mt-md-5">
                    <div class="pt-3 px-3 pt-md-5 pb-0 mt-auto mx-auto promo">
                        <img src="../assets/img/form_text.png" alt="" class="img-fluid">
                    </div>
                    <div class="px-3 mx-auto disclaimer">
                        <img src="../assets/img/promo_period.png" alt="" class="img-fluid">
                    </div>

                    <div class="absolute-position p-2 pb-4 p-md-5">

                        <div class="d-flex flex-row justify-content-around">
                            <div class="car">
                                <img src="../assets/img/masina.png" alt="" class="img-fluid">
                            </div>
                            <!-- <div class="refrigerator">
                                <img src="../assets/img/frigider.png" alt="" class="img-fluid">
                            </div> -->
                        </div>

                        <div class="d-flex flex-row justify-content-around">
                            <!-- <div class="pool">
                                <img src="../assets/img/piscina.png" alt="" class="img-fluid">
                            </div> -->
                            <div class="beer1">
                                <img src="../assets/img/bere.png" alt="" class="img-fluid">
                            </div>
                        </div>

                        <!-- <div class="d-flex flex-column align-items-center">
                            <div class="beer2">
                                <img src="../assets/img/Group66.png" alt="" class="img-fluid">
                            </div>
                        </div> -->
                    </div>

                </div>

                <div class="info-line mt-5">
                    <h4>Infoline <a href="tel:0212075830">021.207.58.30</a></h4>
                </div>

                <div class="mt-5 mb-3">
                    <Arrows></Arrows>
                </div>

            </div>

            <div class="d-flex w-25"></div>

        </div>
    </div>
</template>

<script>
    import Arrows from "@/components/Arrows";

    export default {
        name: "Prizes",
        components: {Arrows}
    }
</script>

<style scoped>

    #prizes_page .logo {
        max-width: 300px;
        max-height: 200px;
    }

    @media (max-width: 1440px) {
        #prizes_page .logo {
            max-width: 25vw;
            max-height: 15vh;
        }
    }

    @media (min-width: 1440px) {
        #prizes_page .header img {
            max-width: 580px;
        }
    }

    @media (max-width: 1439px) and (min-width: 769px) {
        #prizes_page .header img {
            max-width: 480px;
        }
    }

    @media (max-width: 768px) and (min-width: 550px) {
        #prizes_page .header img {
            max-width: 450px;
        }
    }

    #prizes_page .header .text2 {
        margin-top: -6%;
    }

    #prizes_page .prizes {
        position: relative;
        background-image: url("../assets/img/Ellipse1.png");
        background-position: center;
        background-repeat: no-repeat;
        background-size: contain;
        min-height: 540px;
    }

    @media (min-width: 769px) and (max-width: 991px) {
        #prizes_page .prizes {
            min-height: 646px;
        }
    }

    @media (max-width: 991px) {
        #prizes_page .prizes {
            background-size: cover;
        }
    }

    @media (min-width: 991px) {
        #prizes_page .prizes .promo img {
            margin-top: 15%;
        }
    }

    @media (min-width: 991px) and (max-width: 1200px) {
        #prizes_page .prizes .promo {
            max-width: 390px;
        }
    }

    @media (min-width: 600px) and (max-width: 870px) {
        #prizes_page .prizes .promo {
            max-width: 450px;
        }
    }

    @media (min-width: 701px) and (max-width: 870px) {
        #prizes_page .prizes .promo {
            margin-top: 20% !important;
        }
    }

    #prizes_page .prizes .disclaimer {
        max-width: 250px;
        /*margin-top: -3%;*/
    }

    @media (max-width: 500px) {
        #prizes_page .prizes .disclaimer {
            /*margin-top: -5%;*/
            max-width: 60%;
        }
    }

    @media (min-width: 1981px) {
        #prizes_page .prizes .disclaimer {
            /*margin-top: -2%;*/
        }
    }

    @media (min-width: 991px) {
        #prizes_page .details {
            max-width: 850px;
        }
    }

    @media (min-width: 991px) and (max-width: 1500px) {
        #prizes_page .details {
            width: 100% !important;
        }
    }

    #prizes_page .prizes .beer1 {
        position: absolute;
        bottom: 5%;
        right: 5%;
        max-width: 250px;
        z-index: 1050;
    }

    @media (min-width: 991px) and (max-width: 1600px) {
        #prizes_page .prizes .beer1 {
            max-width: 200px;
            bottom: 10%;
        }
    }

    @media (max-width: 991px) {
        #prizes_page .prizes .beer1 {
            bottom: 8%;
            right: 8%;
        }
    }

    @media (min-width: 701px) and (max-width: 870px) {
        #prizes_page .prizes .beer1 {
            max-width: 200px;
        }
    }

    #prizes_page .prizes .car {
        position: absolute;
        left: 10%;
        top: -10%;
        max-width: 450px;
        z-index: 1050;
    }

    @media (min-width: 991px) and (max-width: 1600px) {
        #prizes_page .prizes .car {
            max-width: 400px;
            top: -10%;
        }
    }

    @media (min-width: 891px) and (max-width: 1200px) {
        #prizes_page .prizes .car {
            max-width: 380px;
            top: -5%;
            /* right: 5%; */
        }
    }

    @media (max-width: 891) {
        #prizes_page .prizes .car {
            top: 0;
            /* right: 2%; */
        }
    }

    @media (min-width: 701px) and (max-width: 891px) {
        #prizes_page .prizes .car {
            max-width: 400px;
            top: -5%;
        }
    }

    #prizes_page .prizes .pool {
        position: absolute;
        left: -5%;
        top: 35%;
        max-width: 200px;
        z-index: 1050;
    }

    @media (min-width: 991px) and (max-width: 1400px) {
        #prizes_page .prizes .pool {
            max-width: 190px;
            top: 45%;
            left: -3%;
        }
    }

    @media (min-width: 1250px) and (max-width: 1340px) {
        #prizes_page .prizes .pool {
            left: 5%;
        }
    }

    @media (min-width: 991px) and (max-width: 1024px) {
        #prizes_page .prizes .pool {
            max-width: 150px;
        }
    }

    @media (max-width: 991px) {
        #prizes_page .prizes .pool {
            left: 2%;
            top: 50%;
        }
    }

    #prizes_page .prizes .refrigerator {
        position: absolute;
        right: 5%;
        max-width: 180px;
        bottom: 10%;
        z-index: 1050;
    }

    @media (min-width: 991px) and (max-width: 1100px) {
        #prizes_page .prizes .refrigerator {
            max-width: 130px;
        }
    }

    @media (min-width: 701px) and (max-width: 870px) {
        #prizes_page .prizes .refrigerator {
            bottom: 0;
        }
    }


    #prizes_page .prizes .beer2 {
        position: absolute;
        left: 5%;
        bottom: -10%;
        max-width: 376px;
        z-index: 1050;
    }

    @media (min-width: 991px) and (max-width: 1400px) {
        #prizes_page .prizes .beer2 {
            max-width: 300px;
            left: 10%;
        }
    }

    @media (min-width: 991px) and (max-width: 1024px) {
        #prizes_page .prizes .beer2 {
            bottom: -5%;
        }
    }

    @media (min-width: 700px) and (max-width: 767px) {
        #prizes_page .prizes .beer2 {
            bottom: -15%;
        }
    }

    @media (max-width: 991px) {
        .w-25, .w-50, .w-75 {
            width: 100% !important;
        }
    }

    @media (max-width: 700px) {
        #prizes_page .prizes .beer1, #prizes_page .prizes .car, #prizes_page .prizes .pool,
        #prizes_page .prizes .refrigerator, #prizes_page .prizes .beer2 {
            position: relative;
            left: 0;
            right: 0;
            bottom: 0;
            top: 0;
        }

        #prizes_page .prizes .refrigerator {
            width: 70%;
        }
    }

    .info-line h4, .info-line h4 a {
        color: #FCCA33;
        text-decoration: none;
    }

    .info-line h4 a:hover {
        text-decoration: none;
    }

</style>
